// Mock Amplify configuration for local development
export const amplifyConfig = {
  Analytics: {
    Pinpoint: {
      appId: 'mock-app-id-for-local-development',
      region: 'us-east-1'
    }
  }
};
